import styles from './TextField.module.scss'

export interface TextFieldProps
  extends Pick<
    React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>,
    'autoComplete' | 'autoFocus' | 'className' | 'placeholder' | 'value'
  > {
  error?: string
  onChange: (value: string) => void
  value: string
}

const TextField = ({
  className,
  error,

  onChange,
  ...textfieldProps
}: TextFieldProps) => {
  return (
    <div className={`${styles.container} ${className ?? ''}`} data-testid="textfield-container">
      <div className={[styles.textfieldContainer, error ? styles.error : undefined].join(' ')}>
        <textarea
          className={styles.textfield}
          onChange={(e) => onChange(e.target.value)}
          {...textfieldProps}
          data-testid="textfield"
        />
      </div>

      {error && (
        <div className={styles.error} data-testid="error">
          {error}
        </div>
      )}
    </div>
  )
}

export default TextField
